/* cl-interactive.js — devolve comportamento as secoes clonadas.
 *
 * O `scope_html` do section_kit remove TODO <script> da secao copiada (e o que
 * impede tracking/apps do concorrente de virem junto), o que deixa carrossel,
 * acordeao, aba e "read more" inertes. Este arquivo reimplementa os padroes da
 * froyaorganics.com em JS proprio, escopado ao wrapper do clone.
 *
 * Padroes: (1) Blaze Slider  (2) FAQ s-faq  (3) visual-ingredients
 *          (4) abas what-expect  (5) advisory-circle (nav + read more)
 */
(function () {
  'use strict';

  // ATENCAO: `.cl-pdp` NAO casa com `cl-pdp-main` (token de classe diferente) —
  // o buybox e as miniaturas UGC vivem em .cl-pdp-main, por isso o [class*=].
  var ROOT = '[class*="cl-sec-"], [class*="cl-pdp"]';
  var qsa = function (sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  };

  /* ------------------------------------------------------------------ *
   * 1. Blaze Slider — pista + dots "N of M" + arraste
   * ------------------------------------------------------------------ */
  function initBlaze(slider) {
    if (slider.__clBlaze) return;
    var track = slider.querySelector('.blaze-track');
    if (!track) return;
    var viewport = slider.querySelector('.blaze-track-container') || track.parentElement;
    var slidesNow = function () {
      return Array.prototype.filter.call(track.children, function (n) {
        return n.nodeType === 1;
      });
    };
    if (slidesNow().length < 2) return;
    slider.__clBlaze = true;

    // DELEGACAO, nao um listener por dot: em dois sliders (reviews da PDP e
    // videos da home) a paginacao ainda nao estava no DOM quando o boot rodou.
    // O init marcava __clBlaze (track e slides ja existiam), ligava ZERO
    // listeners, e a guarda de idempotencia impedia nova tentativa — o clique
    // no dot nao fazia nada. Lendo os dots a cada clique isso deixa de importar.
    var dotsNow = function () { return qsa('.blaze-pagination button', slider); };
    var index = 0;

    /* As fotos dos slides sao todas loading="lazy" e o browser so busca as que
     * entram no viewport por SCROLL — mover a pista por `transform` nao dispara
     * isso de forma confiavel. Resultado: ao arrastar, os cards que entram vem
     * sem imagem e aparece uma faixa branca no lugar deles (no slider de
     * reviews da PDP eram 30 de 46 imagens nunca carregadas).
     * Na PRIMEIRA interacao promovemos as imagens do slider a eager: o custo so
     * e pago por quem realmente mexe no carrossel. */
    var eagerDone = false;
    function loadAll() {
      if (eagerDone) return;
      eagerDone = true;
      qsa('img[loading="lazy"]', slider).forEach(function (img) {
        img.loading = 'eager';
        if (img.dataset && img.dataset.src && !img.src) img.src = img.dataset.src;
      });
    }

    /* Duas mecanicas diferentes conforme o CSS do concorrente:
     * - pista com `overflow-x: auto` (reviews da PDP): ela e um container
     *   ROLAVEL. Mover por transform desloca a CAIXA dela para fora do lugar e
     *   o que sobra a direita fica branco — foi a "tarja" reportada. Aqui move-se
     *   por scrollLeft.
     * - pista sem overflow (icons/videos): o clip e do .blaze-track-container e
     *   o movimento e por transform, como o Blaze faz. */
    var ox = getComputedStyle(track).overflowX;
    var scrollMode = (ox === 'auto' || ox === 'scroll')
      && track.scrollWidth > track.clientWidth + 1;

    function maxShift() {
      return scrollMode
        ? Math.max(0, track.scrollWidth - track.clientWidth)
        : Math.max(0, track.scrollWidth - viewport.clientWidth);
    }
    function shiftFor(i) {
      var sl = slidesNow();
      if (!sl[i] || !sl[0]) return 0;
      return Math.min(sl[i].offsetLeft - sl[0].offsetLeft, maxShift());
    }
    function paint(px, animate) {
      if (scrollMode) {
        if (track.scrollTo) {
          track.scrollTo({ left: px, behavior: animate ? 'smooth' : 'auto' });
        } else {
          track.scrollLeft = px;
        }
        return;
      }
      track.style.setProperty('transition-duration', animate ? '300ms' : '0ms', 'important');
      // !important: regras mobile do CSS copiado fixam transform e venceriam o JS
      track.style.setProperty('transform', 'translate3d(' + -px + 'px, 0px, 0px)', 'important');
    }
    function go(i, animate) {
      index = Math.max(0, Math.min(i, slidesNow().length - 1));
      paint(shiftFor(index), animate !== false);
      dotsNow().forEach(function (d, k) { d.classList.toggle('active', k === index); });
    }

    slider.addEventListener('click', function (e) {
      var dot = e.target.closest && e.target.closest('.blaze-pagination button');
      if (!dot || !slider.contains(dot)) return;
      var k = dotsNow().indexOf(dot);
      if (k < 0) return;
      e.preventDefault();
      loadAll();
      go(k);
    });

    /* arraste (o CSS copiado ja promete cursor: grab) */
    var startX = 0, startShift = 0, dragging = false, moved = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.button) return;
      loadAll();
      dragging = true; moved = 0;
      startX = e.clientX;
      startShift = scrollMode ? track.scrollLeft : shiftFor(index);
      track.classList.add('cl-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      moved = e.clientX - startX;
      paint(Math.max(0, Math.min(startShift - moved, maxShift())), false);
    });
    window.addEventListener('pointerup', function () {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('cl-dragging');
      if (Math.abs(moved) < 8) { go(index); return; }
      var target = Math.max(0, Math.min(startShift - moved, maxShift()));
      var best = 0, dist = Infinity, sl = slidesNow();
      sl.forEach(function (s, k) {
        var d = Math.abs((s.offsetLeft - sl[0].offsetLeft) - target);
        if (d < dist) { dist = d; best = k; }
      });
      go(best);
    });

    window.addEventListener('resize', function () { go(index, false); });
  }

  /* ------------------------------------------------------------------ *
   * 2. FAQ (s-faq) — o corpo vive num grid 0fr; abrir e ir para 1fr
   * ------------------------------------------------------------------ */
  function initFaq(item) {
    if (item.__clFaq) return;
    // duas familias de classe, mesmo mecanismo (grid 0fr/1fr): as secoes de
    // conteudo usam s-faq__*, o buybox da PDP usa s-main-product__faq-*
    var title = item.querySelector('.s-faq__faq-title, .s-main-product__faq-title');
    if (!title) return;
    item.__clFaq = true;

    // acessibilidade real — e e o que faz o gate de interacao enxergar o FAQ
    if (!title.hasAttribute('role')) title.setAttribute('role', 'button');
    if (!title.hasAttribute('tabindex')) title.setAttribute('tabindex', '0');
    title.setAttribute('aria-expanded', item.classList.contains('cl-open') ? 'true' : 'false');

    function toggle() {
      var open = item.classList.toggle('cl-open');
      title.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    title.addEventListener('click', toggle);
    title.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
  }

  /* ------------------------------------------------------------------ *
   * 3. Visual ingredients — mesmo grid 0fr/1fr, via .is-open no item
   * ------------------------------------------------------------------ */
  function initVisualIngredient(q) {
    if (q.__clVi) return;
    var item = q.closest('.s-visual-ingredients__item');
    if (!item) return;
    q.__clVi = true;

    function toggle() {
      var open = item.classList.toggle('is-open');
      q.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    q.addEventListener('click', toggle);
    q.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
  }

  /* ------------------------------------------------------------------ *
   * 4. Abas what-expect — troca quais blocos --0/--1 ficam visiveis
   * ------------------------------------------------------------------ */
  function initTabs(section) {
    if (section.__clTabs) return;
    var tabs = qsa('.what-expect__tab', section);
    if (tabs.length < 2) return;
    section.__clTabs = true;

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        tabs.forEach(function (t, k) {
          t.classList.toggle('what-expect__tab--active', k === i);
          t.setAttribute('aria-selected', k === i ? 'true' : 'false');
        });
        qsa('.what-expect__block', section).forEach(function (b) {
          var mine = b.classList.contains('what-expect__block--' + i);
          b.classList.toggle('what-expect__block--hidden', !mine);
        });
      });
    });
  }

  /* ------------------------------------------------------------------ *
   * 5. Advisory circle — setas na viewport rolavel + "read more" por card
   * ------------------------------------------------------------------ */
  function initAdvisory(root) {
    if (root.__clAdv) return;
    root.__clAdv = true;

    var viewport = root.querySelector('[data-viewport]')
      || root.querySelector('.s-advisory-circle__viewport');
    var track = root.querySelector('[data-track]')
      || root.querySelector('.s-advisory-circle__track');

    if (viewport && track) {
      var card = track.querySelector('.s-advisory-circle__card');
      var step = function () {
        if (!card) return viewport.clientWidth;
        var cs = getComputedStyle(track);
        var gap = parseFloat(cs.columnGap || cs.gap) || 20;
        return card.getBoundingClientRect().width + gap;
      };
      var sync = function () {
        var max = track.scrollWidth - viewport.clientWidth - 1;
        qsa('[data-nav]', root).forEach(function (b) {
          var isPrev = b.getAttribute('data-nav') === 'prev';
          var off = isPrev ? viewport.scrollLeft <= 1 : viewport.scrollLeft >= max;
          b.classList.toggle('is-disabled', off);
          b.setAttribute('aria-disabled', off ? 'true' : 'false');
        });
      };
      qsa('[data-nav]', root).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var dir = btn.getAttribute('data-nav') === 'prev' ? -1 : 1;
          viewport.scrollBy({ left: dir * step(), behavior: 'smooth' });
          setTimeout(sync, 420);
        });
      });
      viewport.addEventListener('scroll', sync);
      sync();
    }

    /* "Read more": o JS do concorrente trunca a citacao no cliente, entao a nossa
     * copia herdou so o trecho curto. O texto integral vem do HTML de servidor,
     * guardado em data-cl-full (ver fix_advisory_readmore.py).
     * Delegacao: ao expandir, o <p> e reescrito e o botao antigo sai do DOM. */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-readmore]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();

      var card = btn.closest('.s-advisory-circle__card');
      var quote = btn.closest('.s-advisory-circle__quote');
      if (!card || !quote) return;

      var p = quote.querySelector('p') || quote;
      var full = quote.getAttribute('data-cl-full');
      var expanded = card.classList.toggle('is-expanded');
      var more = btn.getAttribute('data-label-more') || 'Read more';
      var less = btn.getAttribute('data-label-less') || 'Read less';

      if (full) {
        if (expanded) {
          if (!quote.__clShort) quote.__clShort = p.innerHTML;
          p.textContent = full + ' ';
          p.appendChild(btn); // move o proprio no de volta, depois do texto longo
        } else if (quote.__clShort) {
          p.innerHTML = quote.__clShort; // volta com reticencias + botao curto
          return;
        }
      }
      var label = btn.querySelector('[data-readmore-text]') || btn;
      label.textContent = expanded ? less : more;
    });
  }

  /* ------------------------------------------------------------------ *
   * 6. Buybox toggle — switch assinatura <-> compra unica
   * ------------------------------------------------------------------ */
  function initBuyboxToggle(btn) {
    if (btn.__clBbt) return;
    btn.__clBbt = true;
    var scope = btn.closest('[class*="cl-pdp"]') || btn.closest(ROOT);

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var on = btn.getAttribute('aria-checked') !== 'true';
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
      if (scope) scope.classList.toggle('cl-otp', !on);
      // mantem o selling_plan do form coerente com o switch
      qsa('input[name="selling_plan"]', scope || document).forEach(function (inp) {
        if (on) {
          if (inp.__clPlan) inp.value = inp.__clPlan;
        } else {
          if (!inp.__clPlan) inp.__clPlan = inp.value;
          inp.value = '';
        }
      });
    });
  }

  /* ------------------------------------------------------------------ *
   * 7. Video com capa — o botao de play
   * ------------------------------------------------------------------ */
  function initVideo(btn) {
    if (btn.__clVideo) return;
    btn.__clVideo = true;
    var wrap = btn.closest('.js-video__video-wrapper') || btn.parentElement;
    if (!wrap) return;
    var video = wrap.querySelector('video');
    if (!video) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      wrap.classList.add('cl-playing');
      video.setAttribute('controls', '');
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* autoplay bloqueado: controls ficam */ });
    });
  }

  /* ------------------------------------------------------------------ *
   * 8. Miniaturas UGC — troca a capa por um <video> tocando
   * ------------------------------------------------------------------ */
  function initUgcThumb(btn) {
    if (btn.__clUgc) return;
    btn.__clUgc = true;
    var src = btn.getAttribute('data-ugc-video');
    if (!src) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.querySelector('video')) return;
      var v = document.createElement('video');
      v.src = src;
      v.setAttribute('playsinline', '');
      v.setAttribute('controls', '');
      v.autoplay = true;
      btn.appendChild(v);
      btn.classList.add('cl-playing');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  /* ------------------------------------------------------------------ */
  function boot() {
    qsa(ROOT).forEach(function (root) {
      qsa('.blaze-slider', root).forEach(initBlaze);
      qsa('.js-faq__item, .js-main-product__faq-item', root).forEach(initFaq);
      qsa('.s-visual-ingredients__question', root).forEach(initVisualIngredient);
      qsa('.what-expect', root).forEach(initTabs);
      qsa('.s-advisory-circle', root).forEach(initAdvisory);
      qsa('.js-bbt-toggle', root).forEach(initBuyboxToggle);
      qsa('.js-video__play-icon', root).forEach(initVideo);
      qsa('.js-main-product__ugc-thumb', root).forEach(initUgcThumb);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // o theme editor do Shopify re-renderiza secoes sem recarregar a pagina
  document.addEventListener('shopify:section:load', boot);
  window.clInteractiveBoot = boot;
})();
